/* eslint-disable security/detect-object-injection */
import React, { useContext, useState } from 'react';
import { motion } from 'framer-motion';
import { insuranceCompanies } from '../../helpers/insuranceCompanies';
import { insuranceLanguageContent } from '../../pages/InsuranceDocuments/InsuranceLanguageContent';
import ApplicationContext from '../../context/ApplicationContext';

function SearchSelectOnType(props) {
    const { selectedData, setSelectedData, submitSelected } = props;
    const { selectedLanguage } = useContext(ApplicationContext);
    const [show, setShow] = useState(false);

    return (
        <div className='relative'>
            <div className="relative mb-3 justify-center">
                <input data-testid="insurance_carrier" onClick={() =>  setShow(true)} value={selectedData} onChange={(e) => setSelectedData(e.target.value)} autoComplete="off" type="text" id="facility-user-search"
                    className={`w-full mt-1 bg-[#F1F2F2] border ${submitSelected && selectedData.trim() === '' ? 'border-[#B51803]' : 'border-[#797979]'} 
                    py-[10px]  px-[12px] pr-[30px] rounded h-[40px] font-normal text-[#333] text-sm  outline-0 placeholder:text-sm placeholder:text-[#797979]`}
                    placeholder={insuranceLanguageContent['Search and select insurance carrier'][selectedLanguage]} />
                <label htmlFor=""></label>
                {selectedData === '' ? <img src="/images/gray-black-search.svg" alt="search"className="absolute top-[8px] right-[8px] z-[999]" /> : <img onClick={() => {setSelectedData('')}} 
                    src="/images/black-Close.svg" alt="icon"className="absolute top-[14px] right-2.5 w-4 h-4 z-[999] cursor-pointer" />}
            </div>
            {(insuranceCompanies.filter((item) => item.toLowerCase().includes(selectedData.toLowerCase()))).length > 0 && 
            <ul className={`dropdown-menu absolute hidden top-0 left-0 shadow-black bg-[#F2F2F2] border-[#797979] p-2.5 rounded w-full ${show ? 'show ' : ''}`} aria-labelledby="formGroupSelect" style={{inset: 'auto auto auto auto'}}>
                <div className="w-full rounded-lg flex flex-col justify-start py-[12px] px-[8px] pb-0">
                    <div
                        className="Form-scroll overflow-auto pr-2 max-h-[135px]"
                    >
                        {insuranceCompanies.filter((item) => item.toLowerCase().includes(selectedData.toLowerCase()))?.map((item, idx) => (
                            <motion.p initial={{ scale: 0.8 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.2 }}
                                key={`user-${idx}`} data-testid={`user-list-${idx}`} className="cursor-pointer text-base font-normal text-[#333333] pb-[10px]" onClick={() => {setShow(false); 
                                    setSelectedData(item)}}>{item}</motion.p>
                        ))}
                    </div>
                </div>
            </ul>}
            <div className={['filter-overlay cursor-pointer ', show === true ? 'filter-open ' : ''].join('')} onClick={() => {setShow(false); setSearch(''); setIsSearching(''); setCurrentPage(1)}} />
        </div>
    );
}

export default SearchSelectOnType;